import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { LocalService } from './local.services';
import { ScrollService } from './scroll.services';
const routes: Routes = [
    {
        path: 'registro',
        children: [
            {
                path: '1',
                loadChildren: './step1/step1.module#Step1Module',
            },
            {
                path: '2',
                loadChildren: './step2/step2.module#Step2Module',
            },
            {
                path: '3',
                loadChildren: './step3/step3.module#Step3Module',
            },
            {
                path: '4',
                loadChildren: './step4/step4.module#Step4Module',
            },
            {
                path: '5',
                loadChildren: './step5/step5.module#Step5Module',
            },
            {
                path: '6',
                loadChildren: './step6/step6.module#Step6Module',
            },
            {
                path: '7',
                loadChildren: './step7/step7.module#Step7Module',
            },
            {
                path: '8',
                loadChildren: './step8/step8.module#Step8Module',
            },
            {
                path: '9',
                loadChildren: './step9/step9.module#Step9Module',
            },
            {
                path: 'gracias',
                loadChildren: './thank/thank.module#LocalStepThankModule',
            },
        ]
    }
];
@NgModule({
    imports: [
        RouterModule.forChild(routes),
        ScrollToModule.forRoot(),
    ],
    exports: [RouterModule],
    providers: [
        LocalService,
        ScrollService
    ]
})
export class PageLocalModule { }
